// Utility: create a dummy Layer object with required properties and methods
export function createDummyLayer() {
  return {
    getNum: () => 0,
    numbers: { type: "num", num: 1 },
    deepClone: () => ({ getNum: () => 0, numbers: { type: "num", num: 1 } }),
    n: {},
    // Add other properties/methods as needed for your code
  };
}

// Utility: create a general dummy object with common methods
export function createDummyObject() {
  return {
    getNum: () => 0,
    getBeam: () => ({
      deepClone: () => ({}),
      getNum: () => 0,
      getConcrete: () => ({}),
      segments: [],
      n: { one: 1, two: 0 },
    }),
    deepClone: () => ({}),
    getConcrete: () => ({}),
    getConData: () => ({}),
    getReinforcementData: () => ({}),
    id: { guid: "dummy-guid", name: "Dummy Section" },
    type: 0,
    materialCategory: 0,
    ownerType: 0,
    rebars: { grps: [], lays: [] },
    links: { linkGrps: [] },
    designSettings: { rc: { getBeam: () => ({}) } },
    reinforcementData: {},
    conData: {},
    lftZon: { deepClone: () => ({}) },
    rgtZon: { deepClone: () => ({}) },
  };
}
// Utility: create a dummy Layer object with getNum method
// Utility: create a dummy object with required methods for rendering
export function createDummySection() {
  return {
    getNum: () => 0,
    getBeam: () => ({
      deepClone: () => ({}),
      getNum: () => 0,
      getConcrete: () => ({}),
      segments: [],
      n: { one: 1, two: 0 },
    }),
    deepClone: () => ({}),
    getConcrete: () => ({}),
    id: { guid: "dummy-guid", name: "Dummy Section" },
    type: 0,
    materialCategory: 0,
    ownerType: 0,
    rebars: { grps: [], lays: [] },
    links: { linkGrps: [] },
    designSettings: { rc: { getBeam: () => ({}) } },
  };
}
import { ng } from "@common/ngds";

import { ShapeOffset, WidthAtPoint } from "../ngb.wrapper";
import { SectionSection } from "@common/helpers/protoGen";
import { Lang, ITranslationDatabase, MaterialsFetchGuidResponse } from "../../sharedTypes";
import { NGDropdownListItem } from "@common/components/ui-components/SXDropdown";
import { fetchMaterialsFromBackend } from "../mtrl/fetch";
// import http from "../components/common/NGhttp";
//import { RebarTemplate } from "./RebarTemplate";
import { CreateGUID } from "@common/helpers/funlib";
import { useTranslation } from "react-i18next";

const removeNullFromArray = <T>(array: (T | null)[]): T[] => {
  return array.filter((x) => x != null) as T[];
};

// --- Constants ---
const NATIONAL_ANNEXES: Array<ng.eurocode.Annex> = [
  //ng.eurocode.Annex.ANNEX_BELGIUM ,
  ng.eurocode.Annex.ANNEX_COMMON,
  ng.eurocode.Annex.ANNEX_DENMARK,
  //   ng.eurocode.Annex.ANNEX_ESTONIA ,
  ng.eurocode.Annex.ANNEX_FINLAND,
  //  ng.eurocode.Annex.ANNEX_GERMANY ,
  ng.eurocode.Annex.ANNEX_GREAT_BRITAIN,
  //   ng.eurocode.Annex.ANNEX_HUNGARY ,
  //  ng.eurocode.Annex.ANNEX_LATVIA ,
  //   ng.eurocode.Annex.ANNEX_NETHERLAND ,
  ng.eurocode.Annex.ANNEX_NORWAY,
  //  ng.eurocode.Annex.ANNEX_POLAND ,
  //  ng.eurocode.Annex.ANNEX_ROMANIA ,
  //  ng.eurocode.Annex.ANNEX_SPAIN ,
  ng.eurocode.Annex.ANNEX_SWEDEN,
  //   ng.eurocode.Annex.ANNEX_TURKEY,
];

export const getMtrlByIds = (ids: string[], call: (d: ng.material.Data[]) => void) => {
  let querystr: string = "";
  querystr = ids.join("&guids[]=");
  // http.get("/materials/guids?guids[]=" + querystr, (d: MaterialsFetchGuidResponse) => {
  //   if (d.kind === "data") {
  //     call(d.data.map(x => ng.material.Data.fromObject(x)));
  //   }
  //   else {
  //     console.error("Failed to fetch material guids", d);
  //   }
  // }, (e) => {
  //   console.error("Failed to fetch material guids", e);
  // }, false);
};

function LayoutSchema(
  type: ng.reinf.Distribution,
  allRebsInLay: ng.reinf.Straight[],
  grps: ng.reinf.Group[],
  tmpDia: number,
  geo: GeoProps,
  lays: ng.reinf.Layer[],
) {
  let nbrSide, nbrMid, delta;
  let tmpReb, reb_lft, reb_rgt;
  let tmpGrp, grp_lft, grp_rgt;
  let y_lft, y_rgt, w, mid;

  let num = allRebsInLay.length;

  if (num === 1) {
    type = ng.reinf.Distribution.DISTRIBUTION_MID;
  }

  switch (type) {
    case ng.reinf.Distribution.DISTRIBUTION_EVEN: // even spacing BETWEEN bars
      let reb = allRebsInLay[0];
      let y1 = reb.hPos?.start ?? 0;
      let y2 = reb.hPos?.end ?? 0;

      let sumDia = 0;
      for (let ind = 0; ind < num; ind++) {
        const reb = allRebsInLay[ind];

        const grpId = GetGrpID(reb, lays);
        if (grpId === undefined) continue;

        const grp = GetFromIDusingId(grpId, [...grps]);
        if (grp === undefined) continue;

        sumDia += grp.diameter;
      }

      let h1 = (geo.B1 + tmpDia - sumDia) / (num - 1);
      let h2 = (geo.B2 + tmpDia - sumDia) / (num - 1);

      for (let ind = 1; ind < num; ind++) {
        let reb = allRebsInLay[ind - 1];
        const prevGrpId = GetGrpID(reb, lays);
        const prevGrp = prevGrpId ? GetFromIDusingId(prevGrpId, [...grps]) : undefined;

        reb = allRebsInLay[ind];
        const grpId = GetGrpID(reb, lays);
        let grp = grpId ? GetFromIDusingId(grpId, [...grps]) : undefined;
        if (prevGrp !== undefined && grp !== undefined) {
          tmpDia = (prevGrp.diameter + grp.diameter) / 2.0;
        }

        y1 += h1 + tmpDia;
        y2 += h2 + tmpDia;

        if (reb.hPos === null) {
          console.warn("Horizontal position is null", reb);
          reb.hPos = ng.reinf.HorPos.create({});
        }

        // Math.round due to start/end being integers
        reb.hPos.start = Math.round(y1);
        reb.hPos.end = Math.round(y2);
      }
      break;

    case ng.reinf.Distribution.DISTRIBUTION_DENSE_3: // three groups with min spacing BETWEEN bars
      nbrSide = Math.round(num / 3.0);
      nbrMid = num - nbrSide * 2;

      //move right part
      delta = integerDeltaCheck(geo.y1_0 + geo.B1 - (allRebsInLay[num - 1]?.hPos?.start ?? 0));
      for (let ind = nbrSide + nbrMid; ind < num; ind++) {
        let reb = allRebsInLay[ind];
        if (reb.hPos === null) reb.hPos = ng.reinf.HorPos.create({});
        reb.hPos.start += delta;
        reb.hPos.end += delta;
      }

      //move mid part
      // width of mid part
      reb_lft = allRebsInLay[nbrSide];
      y_lft = reb_lft.hPos?.start ?? 0;

      grp_lft = GetFromIDusingIdFailable(GetGrpID(reb_lft, lays), [...grps]);
      if (grp_lft !== undefined) {
        y_lft -= grp_lft.diameter / 2.0;
      }

      reb_rgt = allRebsInLay[nbrSide + nbrMid - 1];
      y_rgt = reb_rgt.hPos?.start ?? 0;

      grp_rgt = GetFromIDusingIdFailable(GetGrpID(reb_rgt, lays), [...grps]);
      if (grp_rgt !== undefined) {
        y_rgt += grp_rgt.diameter / 2.0;
      }

      w = y_rgt - y_lft;

      //find mid-point between rgt and lft part
      reb_lft = allRebsInLay[nbrSide - 1];
      y_lft = reb_lft.hPos?.start ?? 0;

      grp_lft = GetFromIDusingIdFailable(GetGrpID(reb_lft, lays), [...grps]);
      if (grp_lft !== undefined) {
        y_lft += grp_lft.diameter / 2.0;
      }

      reb_rgt = allRebsInLay[nbrSide + nbrMid];
      y_rgt = reb_rgt.hPos?.start ?? 0;

      grp_rgt = GetFromIDusingIdFailable(GetGrpID(reb_rgt, lays), [...grps]);
      if (grp_rgt !== undefined) {
        y_rgt -= grp_rgt.diameter / 2.0;
      }

      mid = (y_rgt + y_lft) / 2.0;

      tmpReb = allRebsInLay[nbrSide];
      delta = mid - w / 2.0 - (tmpReb.hPos?.start ?? 0);

      tmpGrp = GetFromIDusingIdFailable(GetGrpID(tmpReb, lays), [...grps]);
      if (tmpGrp !== undefined) {
        delta += tmpGrp.diameter / 2.0;
      }

      delta = integerDeltaCheck(delta);
      for (let ind = nbrSide; ind < nbrSide + nbrMid; ind++) {
        let reb = allRebsInLay[ind];
        if (reb.hPos === null) {
          console.warn("Horizontal position is null", reb);
          reb.hPos = ng.reinf.HorPos.create({});
        }
        reb.hPos.start += delta;
        reb.hPos.end += delta;
      }
      break;

    case ng.reinf.Distribution.DISTRIBUTION_DENSE_2A: // two groups with min spacing BETWEEN bars, more on left side if odd number
      nbrSide = Math.floor(num / 2.0);
      nbrMid = num - nbrSide * 2;

      //move right part
      tmpReb = allRebsInLay[num - 1];
      delta = geo.y1_0 + geo.B1 - (tmpReb.hPos?.start ?? 0);
      delta = integerDeltaCheck(delta);
      for (let ind = nbrSide + nbrMid; ind < num; ind++) {
        let reb = allRebsInLay[ind];
        if (reb.hPos === null) {
          console.warn("Horizontal position is null", reb);
          reb.hPos = ng.reinf.HorPos.create({});
        }
        reb.hPos.start += delta;
        reb.hPos.end += delta;
      }

      break;

    case ng.reinf.Distribution.DISTRIBUTION_DENSE_2B: // two groups with min spacing BETWEEN bars, more on right side if odd number
      nbrSide = Math.floor(num / 2.0);
      nbrMid = num - nbrSide * 2;

      if (nbrMid > 0) {
        nbrMid--;
      }

      //move right part
      tmpReb = allRebsInLay[num - 1];
      delta = geo.y1_0 + geo.B1 - (tmpReb.hPos?.start ?? 0);
      delta = integerDeltaCheck(delta);
      for (let ind = nbrSide + nbrMid; ind < num; ind++) {
        let reb = allRebsInLay[ind];
        if (reb.hPos === null) {
          console.warn("Horizontal position is null", reb);
          reb.hPos = ng.reinf.HorPos.create({});
        }
        reb.hPos.start += delta;
        reb.hPos.end += delta;
      }

      break;

    case ng.reinf.Distribution.DISTRIBUTION_MID: // one group with min spacing BETWEEN bars centered around mid
      const geoMid = geo.y1_0 + geo.B1 / 2.0;

      reb_lft = allRebsInLay[0];
      y_lft = reb_lft.hPos?.start ?? 0;

      grp_lft = GetFromIDusingIdFailable(GetGrpID(reb_lft, lays), [...grps]);
      if (grp_lft !== undefined) {
        y_lft -= grp_lft.diameter / 2.0;
      }

      reb_rgt = allRebsInLay[num - 1];
      y_rgt = reb_rgt.hPos?.start ?? 0;

      grp_rgt = GetFromIDusingIdFailable(GetGrpID(reb_rgt, lays), [...grps]);
      if (grp_rgt !== undefined) {
        y_rgt += grp_rgt.diameter / 2.0;
      }

      w = y_rgt - y_lft;

      const rebMid = y_lft + w / 2.0;

      delta = geoMid - rebMid;

      delta = integerDeltaCheck(delta);
      for (let reb of allRebsInLay) {
        if (reb.hPos === null) {
          console.warn("Horizontal position is null", reb);
          reb.hPos = ng.reinf.HorPos.create({});
        }
        reb.hPos.start += delta;
        reb.hPos.end += delta;
      }

      break;
    default:
      break;
  }
}

function CreateEvenSpacing(
  tmpLay: ng.reinf.Layer,
  geo: GeoProps,
  cc1: number,
  cc2: number,
  tmpRebars: ng.reinf.Straight[],
) {
  if (tmpLay.id === null) {
    console.error("Layer ID is null", tmpLay);
    return;
  }
  for (let n = 0; n < ((tmpLay as any).getNum?.() ?? 0); n++) {
    let y1 = geo.y1_0 + n * cc1;
    let y2 = geo.y2_0 + n * cc2;

    // let tmpBar = RebarTemplate.deepClone();

    // tmpBar.guid = CreateGUID();
    // tmpBar.layGuid = tmpLay.id.guid;
    // tmpBar.vPos = ng.reinf.VertPos.VERT_POS_CENTER;
    // tmpBar.hPos = ng.reinf.HorPos.create({ start: Math.trunc(y1), end: Math.trunc(y2) });
    // // tmpBar.fullyAnchoredAtStart = false;
    // // tmpBar.fullyAnchoredAtEnd = false;

    // tmpRebars.push(tmpBar);
  }
}

export const isRebarSelected = (focusReinf: string, selReinfs: string[], guid: string) => {
  if (focusReinf === guid) {
    return true;
  }
  for (let selReinf of selReinfs) {
    if (selReinf === guid) {
      return true;
    }
  }
  return false;
};

export function GetRebarPosition(
  sec: ng.geometry.Point2D[],
  reb: ng.reinf.Straight,
  lays: ng.reinf.Layer[],
  grps: ng.reinf.Group[],
) {
  let bb = BoundingBox(sec); // [m]

  let pnt = { x: 0, y: 0, z: 0 };

  let tmpLayID = reb.layGuid;
  let tmpLay = GetFromIDusingId(tmpLayID, [...lays]);
  if (tmpLay === undefined) {
    console.error("Layer is undefined");
    return pnt;
  }
  let tmpGrpID = tmpLay.grpGuid;

  let tmpGrp = GetFromIDusingId(tmpGrpID, [...grps]);
  if (tmpGrp === undefined) {
    console.error("Group is undefined");
    return pnt;
  }
  pnt.x += tmpGrp.start; //[m]

  let d = tmpLay.d * 1e-3; //[m]
  let zon = tmpLay.zone;

  if (reb.hPos === null) {
    console.error("Rebar hor position is null");
    return pnt;
  }

  switch (zon) {
    case ng.design.concrete.BeamSide.BEAM_SIDE_BOTTOM:
      pnt.y += reb.hPos.start * 1e-3;
      pnt.z += bb.minZ + d;
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_RIGHT:
      pnt.y += bb.maxY - d;
      pnt.z += reb.hPos.start * 1e-3;
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_TOP:
      pnt.y += reb.hPos.start * 1e-3;
      pnt.z += bb.maxZ - d;
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_LEFT:
      pnt.y += bb.minY + d;
      pnt.z += reb.hPos.start * 1e-3;
      break;
    default:
      break;
  }

  return pnt;
}

function CheckHorSpace(
  type: "rebars",
  input: {
    rebars: ng.reinf.Straight[];
    grps: ng.reinf.Group[];
    hDist: number;
    lays: ng.reinf.Layer[];
  },
): [boolean, string, string] {
  let msg = "";
  let caption = "";
  let grps, size;

  grps = input.grps;
  size = input.rebars.length;

  for (let i = 1; i < size; i++) {
    const reb1 = input.rebars[i - 1];
    const reb2 = input.rebars[i];

    const getFromIDusingIdGetGrpID = (reb: ng.reinf.Straight, lays: ng.reinf.Layer[], grps: ng.reinf.Group[]) => {
      const found = GetGrpID(reb, lays);
      if (found === undefined) {
        return undefined;
      }
      return GetFromIDusingId(found, grps);
    };

    const grp1 = getFromIDusingIdGetGrpID(reb1, input.lays, [...grps]);
    const grp2 = getFromIDusingIdGetGrpID(reb2, input.lays, [...grps]);

    if (grp1 === undefined || grp2 === undefined) {
      console.error("Group is undefined");
      return [false, "Group is undefined", "dbug"];
    }

    if (reb2.hPos === null || reb1.hPos === null) {
      console.error("Rebar hor position is undefined");
      return [false, "Rebar hor position is undefined", "dbug"];
    }

    let dist = Math.abs(reb2.hPos.start - reb1.hPos.start);
    let check = input.hDist + (grp1.diameter + grp2.diameter) / 2.0;
    if (dist < check) {
      msg = "MSG_rebars_to_close_";
      caption = "rebar_spacing_";
      return [false, msg, caption];
    }
  }

  return [true, msg, caption];
}

/// returns localized error message if there is an error, otherwise returns null
export interface ErrorMessage {
  caption: string;
  text: string;
}
export function ReinfCheck(
  bars: ng.reinf.Straight[],
  projData: ng.input.Data,
  localisation: ITranslationDatabase,
  lang: Lang,
): ErrorMessage | null {
  const [t] = useTranslation();
  let elem = projData.structures[0].elements[0];

  let beam = (elem as any).getBeam?.() ?? {};

  let concElem = beam?.getConcrete();

  let reinfs = concElem?.rebars;

  let grps = reinfs?.grps;
  let lays = reinfs?.lays;
  let rebars = bars;

  console.log("Running reinf check...");

  if (grps === undefined || lays === undefined || rebars === undefined) {
    console.error("Groups, layers or rebars are undefined");
    return { text: "Groups, layers or rebars are undefined", caption: "Groups, layers or rebars are undefined" };
  }

  let msg = "";
  let caption = "";

  // loop through all groups and check for each section where group start or stop
  for (let tmpGrp of grps) {
    let bOK = true;

    for (let i = 0; i < 2; i++) {
      let tmpPos = tmpGrp.start;
      if (i === 1) {
        tmpPos += tmpGrp.length;
      }

      for (let tmpLay of lays) {
        const allRebsAtPos = GetAllReinfsAtPos(tmpPos, [...rebars], [...grps], [...lays]);

        const allRebsAtLevel = GetAllReinfsAtLevel(tmpLay.level, tmpLay.zone, allRebsAtPos, [...lays]);

        [bOK, msg, caption] = CheckHorSpace("rebars", {
          rebars: allRebsAtLevel,
          grps: [...grps],
          hDist: tmpLay.minFreeSpace,
          lays: [...lays],
        });

        // if (!bOK) {
        //   break;
        // }

        if (!bOK) {
          break;
        }
      }

      if (!bOK) {
        break;
      }
    }

    if (!bOK) {
      const cap = caption;
      const text = msg;
      return { caption: cap, text: text };
    }
  }

  return null;
}

export function DeriveSectionOffsets(sec: ng.sections.Section | null, offVec: number[]) {
  let peri = [];

  if (!sec?.polylines?.perimeter?.points) {
    console.error("Perimeter points are undefined");
    return [];
  }

  for (let pnt of sec.polylines.perimeter.points) {
    //NOTE! sec has the form [x, y]!
    if (typeof pnt.x === "undefined") {
      pnt.x = 0;
    }

    if (typeof pnt.y === "undefined") {
      pnt.y = 0;
    }

    let point = {
      x: 0,
      y: pnt.x,
      z: pnt.y,
    };

    peri.push(point);
  }

  let hole = new Array<{ x: number; y: number; z: number }>();

  let offs = ShapeOffset([peri], [hole], [offVec], true);

  return offs[0];
}

export function DerivePeriOffsets(pl: ng.geometry.PolyLine3D, offVec: number[]) {
  let peri = [];

  for (let pnt of pl.points) {
    //NOTE! sec has the form [x, y]!
    if (typeof pnt.x === "undefined") {
      pnt.x = 0;
    }

    if (typeof pnt.y === "undefined") {
      pnt.y = 0;
    }

    if (typeof pnt.z === "undefined") {
      pnt.z = 0;
    }

    let point = {
      x: pnt.x,
      y: pnt.y,
      z: pnt.z,
    };

    peri.push(point);
  }
  let hole = new Array<{ x: number; y: number; z: number }>();

  let offs = ShapeOffset([peri], [hole], [offVec], true);

  pl.points = [];

  for (let pnt of offs[0]) {
    let p3d: ng.geometry.Point3D = { x: pnt.x, y: pnt.y, z: pnt.z } as ng.geometry.Point3D;
    pl.points.push(p3d);
  }

  return pl ?? [];
}

export const integerDeltaCheck = (delta: number) => {
  const rounded = Math.round(delta);
  if (Math.abs(rounded) < 0.5 && Math.abs(delta) > 0) {
    console.warn("delta is rounded to zero and thus IGNORED", delta);
  }
  return rounded;
};

export function UpdateEndRebarPosition(
  allRebsInLay: ng.reinf.Straight[],
  delta: number,
  grpID: string,
  type: "left" | "right" | "both",
  lays: ng.reinf.Layer[],
) {
  // update start/end rebar hor position in this layer -------------------------------------

  delta = integerDeltaCheck(delta);

  if (allRebsInLay.length === 0) {
    console.error("No rebars to update");
    return;
  }

  if (type === "left" || type === "both") {
    const tmpReb = allRebsInLay[0];
    let tmpGrpID = GetGrpID(tmpReb, lays);
    if (tmpGrpID === grpID) {
      if (tmpReb.hPos === null) tmpReb.hPos = ng.reinf.HorPos.create();
      tmpReb.hPos.start += delta;
      tmpReb.hPos.end += delta;
    }
  }

  if (type === "right" || type === "both") {
    const tmpReb = allRebsInLay[allRebsInLay.length - 1];
    let tmpGrpID = GetGrpID(tmpReb, lays);
    if (tmpGrpID === grpID) {
      if (tmpReb.hPos === null) tmpReb.hPos = ng.reinf.HorPos.create();
      tmpReb.hPos.start -= delta;
      tmpReb.hPos.end -= delta;
    }
  }
}

function GetFirstLayer(zon: ng.design.concrete.BeamSide, db: ng.reinf.Layer[]) {
  let ret;

  let allLaysInZone = GetAllLaysInZone(zon, db);

  let size = allLaysInZone.length;

  if (size > 0) {
    ret = allLaysInZone[0];
  }

  return ret;
}

function GetRebarDiameter(reb: ng.reinf.Straight, grps: ng.reinf.Group[], lays: ng.reinf.Layer[]) {
  let tmpLayID = reb.layGuid;
  let tmpLay = GetFromIDusingId(tmpLayID, [...lays]);
  if (tmpLay === undefined) return undefined;

  let tmpGrpID = tmpLay.grpGuid;

  let tmpGrp = GetFromIDusingId(tmpGrpID, [...grps]);
  if (tmpGrp === undefined) return undefined;

  return tmpGrp.diameter;
}

function GetMaxDiaOnSide(
  side: ng.design.concrete.BeamSide,
  rebars: ng.reinf.Straight[],
  lays: ng.reinf.Layer[],
  grps: ng.reinf.Group[],
) {
  let maxDia = 0;

  for (let lay of [...lays]) {
    if (lay.id === null) {
      console.warn("Layer id is null");
      continue;
    }
    let allRebsInLay = GetAllReinfsInLay(lay.id.guid, [...rebars]);
    let size = allRebsInLay.length;

    if (size > 0) {
      let tmpReb;
      if (side === ng.design.concrete.BeamSide.BEAM_SIDE_RIGHT) {
        tmpReb = allRebsInLay[size - 1];
        let dia = GetRebarDiameter(tmpReb, [...grps], [...lays]);
        if (dia && dia > maxDia) {
          maxDia = dia;
        }
      } else {
        tmpReb = allRebsInLay[0];
        let dia = GetRebarDiameter(tmpReb, [...grps], [...lays]);
        if (dia && dia > maxDia) {
          maxDia = dia;
        }
      }
    }
  }

  return maxDia;
}

export function DeriveAutoCov(
  general: ng.beam.ConcreteElement,
  lays: ng.reinf.Layer[],
  bars: ng.reinf.Straight[],
  grps: ng.reinf.Group[],
  secs: SectionSection,
) {
  let tmpGeneral = (general as any).deepClone?.() ?? {};

  // TODO: Here we need a conection to rc-module to automatically calculate cov and vdist
  let pad = 10;
  let defaultDia = 20;

  let maxDia = 0;
  let side = ng.design.concrete.BeamSide.BEAM_SIDE_BOTTOM;
  let tmpLay = GetFirstLayer(side, [...lays]);
  if (tmpLay) {
    maxDia = GetMaxDiaAtLevel(tmpLay.level, tmpLay.zone, [...bars], [...grps], [...lays]);
    const found = tmpGeneral.distances.find((m: ng.design.concrete.CoverAndSpace) => m.side === side);
    if (!found) {
      console.error("Could not find side in general distances", side);
      return tmpGeneral;
    }
    found.cover = maxDia + pad;
    found.space = Math.max(maxDia, defaultDia);
  }

  side = ng.design.concrete.BeamSide.BEAM_SIDE_RIGHT;
  maxDia = GetMaxDiaOnSide(side, [...bars], [...lays], [...grps]);
  var found = tmpGeneral.distances.find((m: ng.design.concrete.CoverAndSpace) => m.side === side);
  if (!found) {
    console.error("Could not find side in general distances", side);
    return tmpGeneral;
  }
  found.cover = maxDia + pad;
  found.space = Math.max(maxDia, defaultDia);

  side = ng.design.concrete.BeamSide.BEAM_SIDE_TOP;
  tmpLay = GetFirstLayer(side, [...lays]);
  if (tmpLay !== undefined) {
    maxDia = GetMaxDiaAtLevel(tmpLay.level, tmpLay.zone, [...bars], [...grps], [...lays]);
    const found = tmpGeneral.distances.find((m: ng.design.concrete.CoverAndSpace) => m.side === side);
    if (!found) {
      console.error("Could not find side in general distances", side);
      return tmpGeneral;
    }
    found.cover = maxDia + pad;
    found.space = Math.max(maxDia, defaultDia);
  }

  side = ng.design.concrete.BeamSide.BEAM_SIDE_LEFT;
  maxDia = GetMaxDiaOnSide(side, [...bars], [...lays], [...grps]);
  found = tmpGeneral.distances.find((m: ng.design.concrete.CoverAndSpace) => m.side === side);
  if (!found) {
    console.error("Could not find side in general distances", side);
    return tmpGeneral;
  }
  found.cover = maxDia + pad;
  found.space = Math.max(maxDia, defaultDia);

  return tmpGeneral;
}

export function GetAllReinfsInLay(id: string, db: ng.reinf.Straight[]) {
  // collect all rebars in this layer
  let allRebsInLay = [];
  for (let reb of db) {
    if (reb.layGuid === id) {
      allRebsInLay.push(reb);
    }
  }

  //order the rebars by there horisontal position from left to right
  allRebsInLay.sort((a, b) => {
    return (a.hPos?.start ?? 0) - (b.hPos?.start ?? 0);
  });

  return allRebsInLay;
}

export function GetAllLaysInZone(zon: ng.design.concrete.BeamSide, db: ng.reinf.Layer[]) {
  //get all existing layers in this zone
  let allLaysInZone = [];
  for (let lay of db) {
    if (lay.zone === zon) {
      allLaysInZone.push(lay);
    }
  }

  //order the layers by there position (level) from low to high
  allLaysInZone.sort((a, b) => {
    return a.level - b.level;
  });

  return allLaysInZone;
}

export function VerticalLayerAdjustmentInZone(
  zon: ng.design.concrete.BeamSide,
  allLaysInZone: ng.reinf.Layer[],
  general: ng.beam.ConcreteElement,
  rebars: ng.reinf.Straight[],
  grps: ng.reinf.Group[],
  lays: ng.reinf.Layer[],
  links: ng.link.Group[] | null,
  concBeamDesSet: ng.design.concrete.Beam | null,
) {
  for (let tmpLay of allLaysInZone) {
    //NOTE! pointer

    // first set the base level for this layer i.e. cov + vert.dists and radius of rebar
    let maxDiaAtLevel = GetMaxDiaAtLevel(tmpLay.level, tmpLay.zone, rebars, [...grps], [...lays]);

    let stirDia = 0;
    if (
      concBeamDesSet?.shearDesignType === ng.design.concrete.ShearDesignType.SHEAR_DESIGN_TYPE_WITH_SHEAR_REINFORCEMENT
    ) {
      for (let stir of links ?? []) {
        if (stir.diameter > stirDia) {
          stirDia = stir.diameter;
        }
      }
    }

    stirDia *= 1e3; // [mm]

    const distance = general.distances.find((m) => m.side === zon);
    let d = distance ? distance.cover + (tmpLay.level - 1) * distance.space + maxDiaAtLevel / 2.0 + stirDia : 0;

    //then check if there are any layers before this layer and if, add their 'thickness' (=maxDia) to level
    for (let tmpLvl = tmpLay.level - 1; tmpLvl > 0; tmpLvl--) {
      let maxDia = 0;
      let tmpMaxDia = GetMaxDiaAtLevel(tmpLvl, zon, rebars, [...grps], [...lays]);
      if (tmpMaxDia > maxDia) {
        maxDia = tmpMaxDia;
      }
      d += maxDia;
    }

    tmpLay.d = Math.round(d);
  }
}

export function COG(peri: ng.geometry.Point2D[]) {
  const iEnd = peri.length - 1;

  let A = 0.0;

  let Cy = 0,
    Cx = 0;

  for (let i = 0; i < iEnd; i++) {
    const yi = peri[i].x;
    const yi1 = peri[i + 1].x;
    const zi = peri[i].y;
    const zi1 = peri[i + 1].y;
    A += yi * zi1 - yi1 * zi;

    Cx = Cx + (yi + yi1) * (yi * zi1 - yi1 * zi);
    Cy = Cy + (zi + zi1) * (yi * zi1 - yi1 * zi);
  }

  A /= 2.0;

  let zero = 1e-6;

  if (Math.abs(Cx) > zero) Cx /= 6.0 * A;
  if (Math.abs(Cy) > zero) Cy /= 6.0 * A;

  return [Cx, Cy];
}

export function BoundingBox(sec: ng.geometry.Point2D[]) {
  let min_y = Number.MAX_VALUE;
  let min_z = Number.MAX_VALUE;
  let max_y = Number.MIN_VALUE;
  let max_z = Number.MIN_VALUE;

  for (let pnt of sec) {
    if (typeof pnt.x === "undefined") {
      pnt.x = 0;
    }

    if (typeof pnt.y === "undefined") {
      pnt.y = 0;
    }

    if (pnt.x < min_y) {
      min_y = pnt.x;
    }
    if (pnt.y < min_z) {
      min_z = pnt.y;
    }
    if (pnt.x > max_y) {
      max_y = pnt.x;
    }
    if (pnt.y > max_z) {
      max_z = pnt.y;
    }
  }

  return { minY: min_y, minZ: min_z, maxY: max_y, maxZ: max_z };
}

export function TranslateSection(inSecs: [ng.sections.Section, ng.sections.Section]) {
  let tmpSecs: [ng.sections.Section, ng.sections.Section] = [
    (inSecs[0] as any).deepClone?.() ?? {},
    (inSecs[1] as any).deepClone?.() ?? {},
  ];

  let sec = tmpSecs[0]; // [m] //TODO: future section will depend on 'x'
  const ngPeri = sec.polylines?.perimeter;
  if (!ngPeri) {
    console.error("Failed to translate empty section");
    return tmpSecs;
  }

  const polylinePoints = ngPeri.points ?? [];

  let bb = BoundingBox(polylinePoints); // [m]

  let peri = new Array<ng.geometry.Point2D>();
  for (let pnt of polylinePoints) {
    //NOTE! this has the form [x, y]!

    if (typeof pnt.x === "undefined") {
      pnt.x = 0;
    }
    if (typeof pnt.y === "undefined") {
      pnt.y = 0;
    }

    let point = ng.geometry.Point2D.create({
      x: pnt.x - bb.minY,
      y: pnt.y - bb.minZ,
    });

    peri.push(point);
  }

  let cog = COG(peri);

  for (let pnt of peri) {
    pnt.x -= cog[0];
    pnt.y -= cog[1];
  }

  ngPeri.points = peri;

  return tmpSecs;
}

export function GetFromIDusingId<T extends { id: { guid: string | null } | null }>(guid: string, db: T[]) {
  for (let tmp of db) {
    if (tmp?.id?.guid === guid) {
      return tmp;
    }
  }

  return undefined;
}
export function GetFromIDusingIdFailable<T extends { id: { guid: string | null } | null }>(
  guid: string | null | undefined,
  db: T[],
) {
  if (guid === null || guid === undefined) return undefined;
  else return GetFromIDusingId(guid, db);
}

export function GetFromIDusingGuid<T extends { guid: string }>(guid: string, db: T[]) {
  for (let tmp of db) {
    if (tmp.guid === guid) {
      return tmp;
    }
  }

  return undefined;
}

export function GetAllReinfsAtPos(
  pos: number,
  bars: ng.reinf.Straight[],
  grps: ng.reinf.Group[],
  lays: ng.reinf.Layer[],
) {
  // collect all rebars at this position
  let allRebsAtPos = new Array<ng.reinf.Straight>();
  for (let tmpBar of bars) {
    let tmpLayID = tmpBar.layGuid;
    let tmpLay = GetFromIDusingId(tmpLayID, [...lays]);
    let tmpGrpID = tmpLay?.grpGuid;
    const grp = tmpGrpID ? GetFromIDusingId(tmpGrpID, grps) : undefined;
    if (grp === undefined) continue;

    if (pos >= grp.start && pos <= grp.start + grp.length) {
      allRebsAtPos.push(tmpBar);
    }
  }

  return allRebsAtPos;
}

export function GetAllReinfsAtLevel(
  level: number,
  zon: ng.design.concrete.BeamSide,
  db: ng.reinf.Straight[],
  lays: ng.reinf.Layer[],
) {
  let allRebsAtLevel = [];
  for (let reb of db) {
    const tmpLay = GetFromIDusingId(reb.layGuid, [...lays]);
    if (tmpLay === undefined) continue;

    if (tmpLay.level === level && tmpLay.zone === zon) {
      allRebsAtLevel.push(reb);
    }
  }

  //order the rebars by there horisontal position from left to right
  allRebsAtLevel.sort((a, b) => {
    if (a.hPos === null) return 0;
    if (b.hPos === null) return 0;
    return a.hPos.start - b.hPos.start;
  });

  return allRebsAtLevel;
}

type ShapeOffsetRet = { x: number; y: number; z: number }[][];
interface WidthAtPointType {
  //specVec = [ double, std::vector<geomfunc::point>, const std::vector<double>]
  w: number;
  pnts: { x: number; y: number; z: number }[];
  dists: number[];
}

export function GetMaxDiaAtLevel(
  level: number,
  zon: ng.design.concrete.BeamSide,
  rebars: ng.reinf.Straight[],
  grps: ng.reinf.Group[],
  lays: ng.reinf.Layer[],
) {
  let maxDia = 0;
  for (let rebar of rebars) {
    const tmpLay = GetFromIDusingId(rebar.layGuid, [...lays]);
    if (tmpLay?.level === level && tmpLay?.zone === zon) {
      const grp = GetFromIDusingId(tmpLay.grpGuid, [...grps]);
      if (grp !== undefined) {
        if (grp.diameter > maxDia) {
          maxDia = grp.diameter;
        }
      }
    }
  }
  return maxDia;
}

export function GetGeoProps(
  x: number,
  secs: [ng.sections.Section, ng.sections.Section],
  lay: ng.reinf.Layer,
  distances: ng.design.concrete.CoverAndSpace[],
  grps: ng.reinf.Group[],
  allRebsInLay: ng.reinf.Straight[],
  lays: ng.reinf.Layer[],
  links: ng.link.Group[] | null,
  concBeamDesSet: ng.design.concrete.Beam | null,
): GeoProps | undefined {
  const sec = secs[0]; // [m] //TODO: future section will depend on 'x'

  if (!sec.polylines?.perimeter) {
    return;
  }

  let bb = BoundingBox(sec.polylines.perimeter.points); // [m]

  // ==============   Get the offseted perimeter to work with ====================

  let peri = [];
  for (let pnt of sec.polylines.perimeter.points) {
    //NOTE! this has the form [x, y]!

    if (typeof pnt.x === "undefined") {
      pnt.x = 0;
    }

    if (typeof pnt.y === "undefined") {
      pnt.y = 0;
    }

    let point = {
      x: 0,
      y: pnt.x,
      z: pnt.y,
    };

    peri.push(point);
  }

  let stirDia = 0;
  if (
    concBeamDesSet?.shearDesignType === ng.design.concrete.ShearDesignType.SHEAR_DESIGN_TYPE_WITH_SHEAR_REINFORCEMENT
  ) {
    for (let stir of links ?? []) {
      if (stir.diameter > stirDia) {
        stirDia = stir.diameter;
      }
    }
  }

  stirDia *= 1e3; // [mm]

  let rightSideCover = distances.find((m) => m.side === ng.design.concrete.BeamSide.BEAM_SIDE_RIGHT)?.cover ?? 0;
  let topSideCover = distances.find((m) => m.side === ng.design.concrete.BeamSide.BEAM_SIDE_TOP)?.cover ?? 0;
  let leftSideCover = distances.find((m) => m.side === ng.design.concrete.BeamSide.BEAM_SIDE_LEFT)?.cover ?? 0;
  let bottomSideCover = distances.find((m) => m.side === ng.design.concrete.BeamSide.BEAM_SIDE_BOTTOM)?.cover ?? 0;

  rightSideCover += stirDia;
  topSideCover += stirDia;
  leftSideCover += stirDia;
  bottomSideCover += stirDia;

  let offVec = [-rightSideCover * 1e-3, -topSideCover * 1e-3, -leftSideCover * 1e-3, -bottomSideCover * 1e-3];

  let hole = new Array<unknown>();
  let offs: ShapeOffsetRet = ShapeOffset([peri], [hole], [offVec], false);

  let off = offs[0];

  //========================================================================

  // from the layer we'll get the zone and the 'd'-value
  // use section and 'x' to extract 'width' and/or 'height'

  // 'd'-value -----------------------------------------------

  let min_d = 0;

  switch (lay.zone) {
    case ng.design.concrete.BeamSide.BEAM_SIDE_BOTTOM:
      min_d = Math.abs(offVec[3]);
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_RIGHT:
      min_d = Math.abs(offVec[0]);
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_TOP:
      min_d = Math.abs(offVec[1]);
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_LEFT:
      min_d = Math.abs(offVec[2]);
      break;
    default:
      min_d = 0;
      break;
  }

  let d = lay.d * 1e-3; // [m]

  if (d < min_d) {
    d = min_d;
  }

  let zon = lay.zone;

  let z = 0,
    y = 0; // [m]

  let tol = 1e-6;

  let line1 = [
    { x: 0, y: 0, z: 0 },
    { x: 0, y: 0, z: 0 },
  ];
  let line2 = [
    { x: 0, y: 0, z: 0 },
    { x: 0, y: 0, z: 0 },
  ];

  let maxDia = GetMaxDiaAtLevel(lay.level, lay.zone, [...allRebsInLay], [...grps], [...lays]) * 1e-3;

  if (maxDia === 0) {
    let tmpGrp = GetFromIDusingId(lay.grpGuid, [...grps]);

    maxDia = 0.5e-3; // used to secure width-measurements

    if (tmpGrp !== undefined) {
      maxDia = tmpGrp.diameter * 1e-3;
    }
  }

  switch (zon) {
    case ng.design.concrete.BeamSide.BEAM_SIDE_BOTTOM:
      z = bb.minZ + d;

      line1[0].z = z + maxDia / 2.0;
      line1[1].y = 1;
      line1[1].z = z + maxDia / 2.0;

      line2[0].z = z - maxDia / 2.0;
      line2[1].y = 1;
      line2[1].z = z - maxDia / 2.0;
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_RIGHT:
      y = bb.maxY - d;

      line1[0].y = y + maxDia / 2.0;
      line1[1].z = 1;
      line1[1].y = y + maxDia / 2.0;

      line2[0].y = z - maxDia / 2.0;
      line2[1].z = 1;
      line2[1].y = z - maxDia / 2.0;
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_TOP:
      z = bb.maxZ - d;

      line1[0].z = z + maxDia / 2.0;
      line1[1].y = 1;
      line1[1].z = z + maxDia / 2.0;

      line2[0].z = z - maxDia / 2.0;
      line2[1].y = 1;
      line2[1].z = z - maxDia / 2.0;
      break;
    case ng.design.concrete.BeamSide.BEAM_SIDE_LEFT:
      y = bb.minY + d;

      line1[0].y = y + maxDia / 2.0;
      line1[1].z = 1;
      line1[1].y = y + maxDia / 2.0;

      line2[0].y = y - maxDia / 2.0;
      line2[1].z = 1;
      line2[1].y = y - maxDia / 2.0;
      break;
    default:
      break;
  }

  //------------------------------------------------------------------------

  let width1: WidthAtPointType = WidthAtPoint(peri, tol, line1); // [m]
  let width2: WidthAtPointType = WidthAtPoint(peri, tol, line2); // [m]

  if (width1.w <= 0) width1 = width2;
  if (width2.w <= 0) width2 = width1;

  let W1 = Math.min(width1.w, width2.w) * 1e3; //[mm]
  let W2 = W1;

  let y1 = 0;
  if (width1.pnts.length > 0) {
    y1 = width1.pnts[0].y * 1e3; //[mm]
  }

  if (width2.w < width1.w && width2.w > 0 && width2.pnts.length > 0) {
    y1 = width2.pnts[0].y * 1e3; //[mm]
  }

  let y2 = y1;

  //--------------------------------------------------------------------------------

  if (off !== undefined) {
    width1 = WidthAtPoint(off, tol, line1); // [m]
    width2 = WidthAtPoint(off, tol, line2); // [m]
  }

  if (width1.w <= 0) width1 = width2;
  if (width2.w <= 0) width2 = width1;

  let B1 = Math.min(width1.w, width2.w) * 1e3; //[mm]
  let B2 = B1;

  let y1_0 = 0;
  if (width1.pnts.length > 0) {
    y1_0 = width1.pnts[0].y * 1e3; //[mm]
  }

  if (width2.w < width1.w && width2.w > 0 && width2.pnts.length > 0) {
    y1_0 = width2.pnts[0].y * 1e3; //[mm]
  }

  let y2_0 = y1_0;

  //--------------------------------------------------------------------------------

  let z1 = z * 1e3; //[mm]
  let z2 = z1;

  // 'y'-values -----------------------------------------------

  // let zon_lft, zon_rgt;

  // switch (zon) {
  //   case "bottom":
  //     zon_lft = "left";
  //     zon_rgt = "right";
  //     break;
  //   case "right":
  //     zon_lft = "bottom";
  //     zon_rgt = "top";
  //     break;
  //   case "top":
  //     zon_lft = "left";
  //     zon_rgt = "right";
  //     break;
  //   case "left":
  //     zon_lft = "top";
  //     zon_rgt = "bottom";
  //     break;
  //   default:
  //     break;
  // }

  const lftZone = distances.find((m) => m.side === ng.design.concrete.BeamSide.BEAM_SIDE_LEFT);
  const rgtZone = distances.find((m) => m.side === ng.design.concrete.BeamSide.BEAM_SIDE_RIGHT);

  const midZone = distances.find((m) => m.side === zon);

  // default start value
  let diameter = 10;
  let uY_lft = diameter / 2.0;
  let uY_rgt = diameter / 2.0;

  if (allRebsInLay.length > 0) {
    let layLft = GetFromIDusingId(allRebsInLay[0].layGuid, lays);
    let layRgt = GetFromIDusingId(allRebsInLay[allRebsInLay.length - 1].layGuid, lays);

    let tmpGrp = layLft ? GetFromIDusingId(layLft.grpGuid, grps) : undefined;
    if (tmpGrp !== undefined) {
      uY_lft = tmpGrp.diameter / 2.0;
    }

    tmpGrp = layRgt ? GetFromIDusingId(layRgt.grpGuid, grps) : undefined;
    if (tmpGrp !== undefined) {
      uY_rgt = tmpGrp.diameter / 2.0;
    }
  }

  y1_0 += uY_lft; // [mm] //TODO: use NGB to find start punkt
  y2_0 += uY_lft; // [mm] //TODO: use NGB to find start punkt

  B1 -= uY_lft + uY_rgt; // [mm]
  B2 -= uY_lft + uY_rgt; // [mm]

  const geo: GeoProps = {
    W1: Math.round(W1),
    W2: Math.round(W2),
    B1: Math.round(B1),
    B2: Math.round(B2),
    z1: Math.round(z1),
    z2: Math.round(z2),
    y1_0: Math.round(y1_0),
    y2_0: Math.round(y2_0),
    y1: Math.round(y1),
    y2: Math.round(y2),
    d: Math.round(d),
    cov: Math.round(midZone?.cover ?? 0),
    vDist: Math.round(midZone?.space ?? 0),
    lftZon: lftZone,
    rgtZon: rgtZone,
  };

  return geo;
}

export interface GeoProps {
  W1: number;
  W2: number;
  B1: number;
  B2: number;
  z1: number;
  z2: number;
  y1_0: number;
  y2_0: number;
  y1: number;
  y2: number;
  d: number;
  cov: number;
  vDist: number;
  lftZon: ng.design.concrete.CoverAndSpace | undefined;
  rgtZon: ng.design.concrete.CoverAndSpace | undefined;
}

export const clone_GeoProps = (x: GeoProps | null) => {
  if (x === null) return null;
  return {
    ...x,
    lftZon: (x.lftZon as any)?.deepClone?.() ?? undefined,
    rgtZon: (x.rgtZon as any)?.deepClone?.() ?? undefined,
  } as GeoProps;
};

export function GetGrpID(reb: ng.reinf.Straight, lays: ng.reinf.Layer[]) {
  let tmpLayID = reb.layGuid;
  let tmpLay = GetFromIDusingId(tmpLayID, [...lays]);
  let tmpGrpID = tmpLay?.grpGuid ?? undefined;

  return tmpGrpID;
}

export async function GetReinfFromDB(
  annex: ng.eurocode.Annex,
  setDbReinfMtrlLst: (x: NGDropdownListItem<string>[]) => void,
  setDbReinfMtrls: (x: ng.material.reinforcement.Data[]) => void,
) {
  let reinfMtrlListItems = new Array<NGDropdownListItem<string>>();
  let reinfMtrlGuids = new Array<string>();

  // for (let tmp in NATIONAL_ANNEXES) {
  //   let annex = (tmp as unknown) as ng.eurocode.Annex;
  // if (annex === undefined) continue;

  let d = await fetchMaterialsFromBackend({ annex });

  if (d.kind === "error") {
    console.error("Error fetching materials from backend", d.error);
    return;
  }

  // -------------------- collect all reinf materials guids in a list -------------------
  const tmpFun = (k: string) => {
    if (d.kind === "error") return;

    let tmpGrp = k;
    if (tmpGrp !== "Reinforcement") return;

    const group = (d.data as any)[k];
    if (group === undefined) return;

    for (let tmpMtrl of group) {
      if (reinfMtrlGuids.indexOf(tmpMtrl.guid) > -1) continue;

      reinfMtrlListItems.push({ id: tmpMtrl.guid, name: tmpMtrl.name });
      reinfMtrlGuids.push(tmpMtrl.guid);
    }
  };

  Object.keys(d.data).map((k, i) => {
    return tmpFun(k);
  });

  let pagination = d.pagination;

  for (let page = 2; page <= pagination.TotalPageCount; page++) {
    d = await fetchMaterialsFromBackend({ annex, page });
    if (d.kind === "error") {
      console.error("Error fetching materials from backend", d.error);
      return;
    }

    Object.keys(d.data).map((k, i) => {
      return tmpFun(k);
    });
  }
  // }

  setDbReinfMtrlLst(reinfMtrlListItems);

  //--------------------------------------------------------------

  // now fetch the reinf materials so that we can get the diameters
  getMtrlByIds(reinfMtrlGuids, (d) => {
    let reinfMtrls = d.map((mtrl) => (mtrl as any).getReinforcementData?.());
    setDbReinfMtrls(removeNullFromArray(reinfMtrls));
  });
}

export async function GetConcFromDB(
  setDbConcMtrlLst: (x: NGDropdownListItem<string>[]) => void,
  setDbConcMtrls: (x: ng.material.concrete.Data[]) => void,
) {
  let concMtrlListItems = new Array<NGDropdownListItem<string>>();
  let concMtrlGuids = new Array<string>();

  // for (let tmp of NATIONAL_ANNEXES) {
  //   let annex = (tmp as unknown) as ng.eurocode.Annex;
  //   if (annex === undefined) continue;

  let annex = ng.eurocode.Annex.ANNEX_UNSPECIFIED;

  let d = await fetchMaterialsFromBackend({ annex });

  if (d.kind === "error") {
    console.error("Error fetching materials from backend", d.error);
    return;
  }

  // -------------------- collect all reinf materials guids in a list -------------------
  const tmpFun = (k: string) => {
    if (d.kind === "error") return;

    let tmpGrp = k;
    if (tmpGrp !== "Concrete") return;

    const group = (d.data as any)[k];
    if (group === undefined) return;

    for (let tmpMtrl of group) {
      if (concMtrlGuids.indexOf(tmpMtrl.guid) > -1) continue;

      concMtrlListItems.push({ id: tmpMtrl.guid, name: tmpMtrl.name });
      concMtrlGuids.push(tmpMtrl.guid);
    }
  };

  Object.keys(d.data).map((k, i) => {
    return tmpFun(k);
  });

  let pagination = d.pagination;

  for (let page = 2; page <= pagination.TotalPageCount; page++) {
    d = await fetchMaterialsFromBackend({ annex, page });
    if (d.kind === "error") {
      console.error("Error fetching materials from backend", d.error);
      return;
    }

    Object.keys(d.data).map((k, i) => {
      return tmpFun(k);
    });
  }
  // }

  setDbConcMtrlLst(concMtrlListItems);

  //--------------------------------------------------------------

  // now fetch the reinf materials so that we can get the diameters
  getMtrlByIds(concMtrlGuids, (allMaterials) => {
    setDbConcMtrls(removeNullFromArray(allMaterials.map((m) => (m as any).getConData?.())));
  });
}

export function convertToMM(val: number) {
  return Math.round(Number(val) * 1e3 * 100) / 100;
}

export function CreateRebars(
  tmpRebars: ng.reinf.Straight[],
  tmpLay: ng.reinf.Layer,
  tmpLays: ng.reinf.Layer[],
  grps: ng.reinf.Group[] | null,
  secs: [ng.sections.Section, ng.sections.Section] | null,
  general: ng.beam.ConcreteElement | null,
  links: ng.link.Group[] | null,
  concBeamDesSet: ng.design.concrete.Beam | null,
) {
  if ((tmpLay as any).numbers?.type !== "num") {
    console.error("Number of rebars is undefined", tmpLay);
    return;
  }
  if ((tmpLay as any).numbers?.num === 0) return; // no rebars in this layer so far
  if (tmpLay.id === null) {
    console.error("Layer ID is null", tmpLay);
    return;
  }
  if (grps === null) {
    console.error("Groups data is null");
    return;
  }
  // if (links === null) {
  //   console.error('Links data is null');
  //   return;
  // }
  if (secs === null) {
    console.error("Sections are null");
    return;
  }
  if (general === null) {
    console.error("General data is null");
    return;
  }

  // let tmpReb = RebarTemplate.deepClone();
  // tmpReb.layGuid = tmpLay.id.guid;

  const geo = GetGeoProps(
    0,
    secs,
    tmpLay,
    general.distances,
    [...grps],
    tmpLays as any,
    links as any,
    concBeamDesSet as any,
    {} as any, // 9th dummy argument for development
  );
  if (geo === undefined) {
    console.error("GeoProps is undefined");
    return;
  }

  let dia = 0;
  let tmpGrp = GetFromIDusingId(tmpLay.grpGuid, [...grps]);
  if (tmpGrp !== undefined) {
    dia = tmpGrp.diameter;
  }

  let cc1 = 0,
    cc2 = 0;
  let cc_min = tmpLay.minFreeSpace + dia;
  if ((tmpLay as any).numbers?.type === "num" && (tmpLay as any).numbers?.num > 1) {
    cc1 = geo.B1 / ((tmpLay as any).numbers.num - 1);
    cc2 = geo.B2 / ((tmpLay as any).numbers.num - 1);

    if (cc1 < cc_min) {
      (tmpLay as any).numbers.num = Math.floor(geo.B1 / cc_min) + 1;
      cc1 = geo.B1 / ((tmpLay as any).numbers.num - 1);
    }
    if (cc2 < cc_min) {
      (tmpLay as any).numbers.num = Math.floor(geo.B2 / cc_min) + 1;
      cc2 = geo.B2 / ((tmpLay as any).numbers.num - 1);
    }
  }

  const num = (tmpLay as any).numbers.num;

  CreateEvenSpacing(tmpLay, geo, cc1, cc2, tmpRebars);
  let allRebsInLay = GetAllReinfsInLay(tmpLay.id.guid, tmpRebars); // NOTE! pointer

  let y1 = geo.y1_0;
  let y2 = geo.y2_0;

  // begin with no spacing scheme, just the cc_min ----------------------
  let reb = allRebsInLay[0];

  if (reb === undefined || reb.hPos === null) {
    console.error("Horizontal position is null", reb);
    return;
  }

  // Math.round due to start/end being integers
  reb.hPos.start = Math.round(y1);
  reb.hPos.end = Math.round(y2);

  for (let ind = 1; ind < num; ind++) {
    reb = allRebsInLay[ind];
    let tmpGrpID = GetGrpID(reb, tmpLays);
    if (tmpGrpID === undefined) {
      console.error("Group ID is null", reb);
      continue;
    }

    let prevDia = 0;
    let tmpGrp = GetFromIDusingId(tmpGrpID, [...grps]);
    if (tmpGrp !== undefined) {
      prevDia = tmpGrp.diameter;
    }
    let tmpDia = 0;
    tmpGrp = GetFromIDusingId(tmpGrpID, [...grps]);
    if (tmpGrp !== undefined) {
      tmpDia = tmpGrp.diameter;
    }

    let cc_min = tmpLay.minFreeSpace + (prevDia + tmpDia) / 2.0;

    y1 += cc_min;
    y2 += cc_min;

    console.assert(reb.hPos, "Horizontal position is invalid");
    // Math.round due to start/end being integers
    reb.hPos!.start = Math.round(y1);
    reb.hPos!.end = Math.round(y2);
  }

  // space rebars according to spacing scheme ----------------------
  LayoutSchema(tmpLay.distr, allRebsInLay, [...grps], dia, geo, [...tmpLays]);
}

export function UpdateRebars(
  tmpLay: ng.reinf.Layer,
  tmpLays: ng.reinf.Layer[],
  bars: ng.reinf.Straight[],
  grps: ng.reinf.Group[] | null,
  general: ng.beam.ConcreteElement | null,
  secs: [ng.sections.Section, ng.sections.Section] | null,
  links: ng.link.Group[] | null,
  concBeamDesSet: ng.design.concrete.Beam | null,
) {
  if (bars === null) {
    console.error("Reinforcement data is null");
    return;
  }
  if (tmpLay.id === null) {
    console.error("Layer ID is null", tmpLay);
    return;
  }

  let tmpRebs = [];
  //remove all rebars from layer
  for (let tmpReb of [...bars]) {
    if (tmpReb.layGuid !== tmpLay.id.guid) {
      tmpRebs.push(tmpReb);
    }
  }

  CreateRebars(tmpRebs, tmpLay, tmpLays, grps, secs, general, links, concBeamDesSet);

  // update all layers in this zone
  const zon = tmpLay.zone;

  let allLaysInZone = GetAllLaysInZone(zon, tmpLays); // NOTE! pointer (ordered according to level)
  if (!general) {
    console.error("General data is null, can't do vertical layer adjustment");
    return;
  }
  VerticalLayerAdjustmentInZone(
    zon,
    allLaysInZone,
    general,
    tmpRebs,
    grps ? [...grps] : [],
    tmpLays,
    links,
    concBeamDesSet,
  );

  return [...tmpRebs];
}

export function RemoveRebars(layGuid: string, bars: ng.reinf.Straight[]) {
  let tmpRebs = [];

  if (bars)
    for (let tmpReb of [...bars]) {
      if (tmpReb.layGuid === layGuid) {
        continue;
      }
      tmpRebs.push(tmpReb);
    }

  bars = tmpRebs;
}

export function CreateReinfs(
  lays: ng.reinf.Layer[] | null,
  reinfs: ng.rebar.Data | null,
  secs: [ng.sections.Section, ng.sections.Section] | null,
  grps: ng.reinf.Group[] | null,
  general: ng.beam.ConcreteElement | null,
  links: ng.link.Group[] | null,
  concBeamDesSet: ng.design.concrete.Beam | null,
): ng.reinf.Straight[] {
  if (lays == null || reinfs === null || secs === null || grps === null || general === null || links === null) {
    console.error("Invalid data for CreateReinfs()");
    return [];
  }

  let tmpBars = new Array<ng.reinf.Straight>();

  for (let lay of [...lays]) {
    if ((lay as any).id === null || (lay as any).numbers === null) {
      console.warn("Missing layer data", lay);
      continue;
    }

    tmpBars = UpdateRebars(lay, lays, tmpBars, grps, general, secs, links, concBeamDesSet) as ng.reinf.Straight[];
  }

  return tmpBars;
}

export function ReinfUpdate(
  lays: ng.reinf.Layer[] | null,
  reinfs: ng.rebar.Data | null,
  secs: [ng.sections.Section, ng.sections.Section] | null,
  grps: ng.reinf.Group[] | null,
  general: ng.beam.ConcreteElement | null,
  links: ng.link.Group[] | null,
  concBeamDesSet: ng.design.concrete.Beam | null,
  setBars?: (x: ng.reinf.Straight[]) => void,
) {
  if (reinfs === null) {
    return false;
  }

  let bars: ng.reinf.Straight[] = CreateReinfs(lays, reinfs, secs, grps, general, links, concBeamDesSet);

  if (setBars) setBars(bars);

  reinfs.bars = bars; //update context

  console.log("Reinforcement updated");
}
